import type { TechnicianAttachment } from "@myapp/contract";
import { hasAnyRole } from "@myapp/contract";
import { useAuthStore } from "../../auth";

/**
 * Who is looking at the card, reduced to the two facts the removal rule needs: the user's id
 * (a worker removes only their own uploads) and whether they are the office (removes anything).
 * `user.id` is a string on the auth store, the attachment's `uploadedBy.id` a number — same
 * coercion the worker pages already do for `technicianId`.
 */
export function useFeedbackActor() {
  const user = useAuthStore((state) => state.user);
  const currentUserId = Number(user?.id ?? 0);
  const isOffice = hasAnyRole(user?.roles ?? [], ["MANAGER", "DIRECTOR", "SUPERUSER"]);

  const canRemove = (item: TechnicianAttachment) => isOffice || item.uploadedBy.id === currentUserId;

  return { currentUserId, isOffice, canRemove };
}
